import { render, staticRenderFns } from "./AdmisionPaciente.vue?vue&type=template&id=7ae754c2&scoped=true"
import script from "./AdmisionPaciente.vue?vue&type=script&lang=js"
export * from "./AdmisionPaciente.vue?vue&type=script&lang=js"
import style0 from "./AdmisionPaciente.vue?vue&type=style&index=0&id=7ae754c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae754c2",
  null
  
)

export default component.exports